import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const TotpKeysServiceContext = createContext(undefined)

const TotpKeysServiceProvider = ({
  children,
  oauthApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={TotpKeysServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={oauthApiHost}
      valueCallback={(axios) => ({
        create: async () => {
          // POST /auth/totp/me/totp_keys - Regenerate TOTP key
          const {data} = await axios.post('/auth/totp/me/totp_keys')
          return data
        },
        get: async (id) => {
          // GET /auth/totp/me/totp_keys/me - Get or create TOTP key
          const {data} = await axios.get(`/auth/totp/me/totp_keys/${id}`)
          return data
        },
        update: async (id, payload) => {
          // PATCH /auth/totp/me/totp_keys/me - Verify TOTP key with code
          const {data} = await axios.patch(`/auth/totp/me/totp_keys/${id}`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

TotpKeysServiceProvider.propTypes = {
  children: PropTypes.node.isRequired,
  oauthApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useTotpKeysService = () => {
  const context = useContext(TotpKeysServiceContext)
  if (context === undefined) {
    throw new Error('useTotpKeysService must be used within a TotpKeysServiceProvider')
  }
  return context
}

const useCurrentTotpKeyQuery = ({accessToken, enabled, ...otherProps}) => {
  const totpKeysService = useTotpKeysService()
  return useSimpleQuery({
    queryKey: `totp_keys-get-${accessToken}`,
    queryFn: async () => totpKeysService.get('me'),
    enabled: enabled !== undefined ? enabled : !!accessToken,
    ...otherProps
  })
}

export {TotpKeysServiceProvider, useTotpKeysService, useCurrentTotpKeyQuery}
